import React from 'react';
import {
  EyeOff, Banknote, Zap, Brain,
  MessageSquareText, Gauge, UsersRound, BellRing
} from 'lucide-react';
import { useLanguage } from '../../assets/js/LanguageContext';
import SectionEyebrow from '../common/SectionEyebrow';
import InfoCard from '../common/InfoCard';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/HomeProblems.css';

/* Cada tarjeta cuenta el problema y, bajo el filete, lo que hace The Pulse con
 * el. Antes eran dos bloques (los problemas arriba, los beneficios abajo) y por
 * mucho que compartieran franja se seguian leyendo como dos listas.
 *
 * Las cuatro respuestas empiezan por un verbo dirigido al lector, no por una
 * etiqueta de producto: la de arriba es la queja del cliente y la de abajo lo
 * que se lleva. Antes eran los cuatro beneficios de la seccion "Solucion", y
 * dos de ellos ("Participacion 360", "Flexibilidad en la ejecucion") eran
 * caracteristicas de la herramienta, que no contestan a un miedo. Siguen en
 * lang.json para la seccion de como funciona, que es donde encajan. */
const PROBLEMS = [
  { id: 1, accent: '#7C3AED', icon: EyeOff, answerIcon: MessageSquareText,
    titleKey: 'home1_card1_title', textKey: 'home1_problem1', answerKey: 'home1_answer1' },
  { id: 2, accent: '#2563EB', icon: Zap, answerIcon: Gauge,
    titleKey: 'home1_card3_title', textKey: 'home1_problem3', answerKey: 'home1_answer2' },
  { id: 3, accent: '#C026D3', icon: Banknote, answerIcon: UsersRound,
    titleKey: 'home1_card2_title', textKey: 'home1_problem2', answerKey: 'home1_answer3' },
  { id: 4, accent: '#0D9488', icon: Brain, answerIcon: BellRing,
    titleKey: 'home1_card4_title', textKey: 'home1_problem4', answerKey: 'home1_answer4' }
];

const HOME_1 = () => {
  const { t } = useLanguage();

  return (
    <section id="que-hacemos" className="section-band">
      <div className="section-band__inner">
        <div className="section-band__head">
          <SectionEyebrow>{t('home1_title')}</SectionEyebrow>
          <p className="section-band__lead">{t('home2_subtitle')}</p>
        </div>

        {/* El id vive aqui para que el enlace del menu a "solucion" siga
            llevando al sitio correcto. */}
        <div id="solucion" className="problems-grid">
          {PROBLEMS.map((problem) => {
            const Icon = problem.icon;
            const AnswerIcon = problem.answerIcon;
            return (
              <InfoCard
                key={problem.id}
                title={t(problem.titleKey)}
                description={t(problem.textKey)}
                accent={problem.accent}
                icon={<Icon size="1em" strokeWidth={1.5} />}
                footer={
                  <>
                    <span className="info-card__footer-label">
                      {t('home1_answer_label')}
                    </span>
                    <span className="info-card__footer-answer">
                      <AnswerIcon size={18} strokeWidth={2} aria-hidden="true" />
                      {t(problem.answerKey)}
                    </span>
                  </>
                }
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HOME_1;
